import { useId, useRef, useState } from "react";
import { usePmsTheme } from "../../../Components/PmsThemeContext";
import { InventoryWorkspaceDialog } from "../InventoryFilterPopup";
import { getUnitMessages } from "../unitMessages";
import { getOfficialUnitName } from "../../utils/unitNames";
import "./AddUnitPopup.css";

export default function UnitAliasDialog({ unit, hotelName, onClose, onSave }) {
  const { languageId } = usePmsTheme();
  const words = getUnitMessages(languageId);
  const formId = useId();
  const [value, setValue] = useState(unit.display_name || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef(false);
  const close = () => { if (!pending.current) onClose(); };
  const save = async (event) => {
    event.preventDefault();
    if (pending.current) return;
    pending.current = true;
    setSaving(true);
    setError("");
    try {
      await onSave(value.trim());
      onClose();
    } catch (failure) {
      setError(failure.response?.data?.error || words.saveError);
    } finally {
      pending.current = false;
      setSaving(false);
    }
  };
  const official = getOfficialUnitName(unit, languageId);
  return <InventoryWorkspaceDialog title={words.editAlias} onClose={close} actions={<>
    <button type="button" onClick={close} disabled={saving}>{words.cancel}</button>
    <button type="submit" form={formId} className="inventory-workspace-dialog__primary" disabled={saving}>{saving ? words.saving : words.aliasSave}</button>
  </>}>
    <form id={formId} className="pu-unit-form" onSubmit={save} aria-busy={saving}>
      <p className="pu-unit-form__hint">{hotelName && <><strong>{hotelName}</strong><br /></>}{words.officialName}: {official} ({unit.code})</p>
      <label className="pu-unit-form__field">
        <span>{words.hotelName}</span>
        <input name="display_name" data-inventory-autofocus value={value} onChange={(event) => setValue(event.target.value)}
          aria-describedby={formId + "-hint"} placeholder={official} disabled={saving} autoComplete="off" maxLength={100} />
      </label>
      <p className="pu-unit-form__hint" id={formId + "-hint"}>{words.aliasHint}</p>
      {error && <div className="pu-unit-form__error" role="alert">{error}</div>}
    </form>
  </InventoryWorkspaceDialog>;
}
